const loadGMaps = () => {
    return new Promise((resolve, reject) => {
        Promise.all([loadGMAPScript(),loadOMSScript()])
            .then(()=>{
                resolve(true)
            })
            .catch(()=>{
                resolve(false)
            })
    })
};
function loadOMSScript(){
    return new Promise((resolve, reject) => {
        
        const existingScriptOMS = document.getElementById('overlappingMarker');
        if (!existingScriptOMS) {
            const script = document.createElement('script');
            script.src = process.env.CDN_URL + "/vendors/OverlappingMarkerSpiderfier/1.0.3/oms.min.js?&from=adopta";
            script.id = 'overlappingMarker';
            document.body.appendChild(script);
            script.onload = () => {
                if (resolve) resolve();
            };
        }
        if (existingScriptOMS && resolve) {
            resolve();
        }
    })
}

function loadGMAPScript(){
    return new Promise((resolve, reject) => {
        
        const existingScriptOMS = document.getElementById('googleMapsScript');
        if (!existingScriptOMS) {
            const script = document.createElement('script');
            script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyARBUjh_6oeCBKOQg-bMx3d_WNbH3fhQVw&libraries=&v=weekly&language=es&region=ES&from=adopta&callback=Function.prototype";
            script.id = 'googleMapsScript';
            document.body.appendChild(script);
            script.onload = () => {
                if (resolve) resolve();
            };
        }
        if (existingScriptOMS && resolve) {
            resolve();
        }
    })
}




export default loadGMaps;